/**
 * Sends a GET request to retrieve catalog data.
 * 
 * @returns {Promise<object|null>} - Returns a Promise that resolves to the catalog data if the request is successful, or null if there is an error or no data is received.
 */
export const getData = async () => {
    try {
        const response = await fetch('https://d10xp9krdkfyts.cloudfront.net/api/catalogData', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const data = await response.json();

        if (data) {
            return data;
        } else {
            alert('No data received.');
            return null;
        }
    } catch (error) {
        alert('Unable to fetch data from server');
        console.error('Error:', error);
        return null;
    }
};
